import { Component } from "@angular/core";

@Component({
  selector: 'header-title',
  template: `<ng-content>header-title</ng-content>`,
})
export class HeaderTitleComponent {}